export const ACTION_IS_LOADING = 'ACTION_IS_LOADING';

export const setIsLoading = (payload) => ({type: ACTION_IS_LOADING, payload});